import { MediaStorageType } from "../models/models.swagger.generated";

export class MediaStorageTypeHelper {
  public static mapFileTypeToMediaType(fileType: string): MediaStorageType {
    if (!fileType) {
      return null;
    }
    const type = fileType.toLowerCase();
    for (const enumMember in MediaStorageType) {
      if (typeof(enumMember) === 'string' && enumMember.toLowerCase() === type) {
        return MediaStorageType[enumMember as string];
      }
    }
    return null;
  }
}

